const KeenSlider = window.KeenSlider

const { useAutoplay } = window.BAO.Carousel.plugins

class DropdownAnnouncementBar extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.hasAttribute('data-date')) {
      const closedDate = new Date(this.getAttribute('data-date'))
        .toISOString()
        .slice(0, 10)
      const currentDate = new Date().toISOString().slice(0, 10)

      if (currentDate > closedDate) {
        this.deleteCartAttribute()
      }
    }

    if (this.ariaHidden) return

    this.setAttribute('aria-hidden', 'false')

    if (this.els.slide.elements.length < 2) return

    this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.handleClose = this.handleClose.bind(this)

    if (this.els?.close?.elements) {
      this.els.close.elements.forEach(closeEl => {
        this.listeners.add(closeEl, 'click', this.handleClose)
      })
    }
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slideChanged: this.onSlideChanged,
      },
      [useAutoplay(4, { pauseOnHover: true })],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })
  }

  async handleClose () {
    this.setAttribute('aria-hidden', 'true')

    // eslint-disable-next-line compat/compat
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [this.storageName]: new Date().toISOString().slice(0, 10),
        },
      }),
    })
  }

  async deleteCartAttribute () {
    // eslint-disable-next-line compat/compat
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [this.storageName]: null,
        },
      }),
    })
  }

  get storageName () {
    return 'hide_dropdown_announcement_date'
  }
}

if (!customElements.get('dropdown-announcement-bar')) {
  customElements.define('dropdown-announcement-bar', DropdownAnnouncementBar)
}
